<template>
  <v-navigation-drawer app v-model="drawer" color="white" left permanent light floating width="247">
    <v-list>
      <v-list-item
        class="align-center justify-center"
        style="margin-bottom: 84.5px; margin-top: 40px"
      >
        <img width="100" :src="require(`@/assets/logo.png`)" />
      </v-list-item>
      <router-link
        v-for="item in menuItems"
        :key="item.name"
        :to="item.link"
        style="text-decoration: none;"
      >
        <v-list-item>
          <v-list-item-content
            class="text-center"
            @click="selectedItem = item.name"
            :class="{
					sidebarItemActive: (selectedItem === item.name),
					sidebarItem: (selectedItem !== item.name),
				}"
          >
            <v-list-item-title
              style="text-decoration: none;"
              :class="{
						sidebarItemContent: (selectedItem !== item.name), 
						sidebarItemContentActive: (selectedItem === item.name),
					}"
            >{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      selectedItem: "Home",
      menuItems: [
        {
          name: "Home",
          text: "Home",
          link: "/"
        },
        {
          name: "Procedimento",
          text: "Procedimento",
          link: "/procedimento"
        },{
          name: "Financeiro",
          text: "Financeiro",
          link: "/financeiro"
        },
        {
          name: "Contas",
          text: "Contas",
          link: "/contas"
        },
        {
          name: "Administrador",
          text: "Administrador",
          link: "/administrador"
        }
      ]
    };
  },
  watch: {
    $route(to) {
      this.menuItems.forEach(item => {
        if (item.link === to.path) this.selectedItem = item.name;
      });
    }
  },
  mounted() {
    this.menuItems.forEach(item => {
      if (item.link === this.$route.path) this.selectedItem = item.name;
    });
  }
};
</script>

<style scoped>
.sidebarItem {
  width: 196px;
  height: 56px;
  border-radius: 12px;
}

.sidebarItemActive {
  width: 196px;
  height: 56px;
  background: #0439d9;
  border-radius: 12px;
}

.sidebarItemContentActive {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #fff;
}

.sidebarItemContent {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #212121;
}
</style>